import axios from 'axios';
import {
  Container, Grid, Button, Select, MenuItem, Backdrop, CircularProgress, InputLabel, Dialog,
  DialogTitle, DialogContent, DialogContentText, DialogActions, FormControl, RadioGroup,
  FormControlLabel, Radio, FormLabel, TextField, Typography
} from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import mapboxgl from 'mapbox-gl';
import MapboxDirections from '@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions';
import { Form } from 'react-bootstrap';
import '../styles/Map.css';
import React, { PureComponent } from 'react';
import moment from 'moment';
import { convertMeterToMile, convertSecondToHour, getAPIUrl } from '../helpers/CommonHelper';

mapboxgl.accessToken = 'pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4M29iazA2Z2gycXA4N2pmbDZmangifQ.-g_vE53SD2WrJ6tFX7QHmA';

class Map extends PureComponent {
  mapContainerRef = React.createRef();

  directions = null;

  constructor(props) {
    super(props);

    this.state = {
      pickupDate: new Date(new Date().getTime() + (1 * 60 * 60 * 1000)),
      dropDate: new Date(new Date().getTime() + (5 * 60 * 60 * 1000)),
      isLoading: false,
      originCord: null,
      originAddress: '',
      originAddressDetail: '',
      dropCord: null,
      dropAddress: '',
      dropAddressDetail: '',
      vehicleType: 'sedan',
      duration: null,
      distance: null,
      parcelWeight: null,
      showAssistAvailable: false,
      parcelAssistAvailable: 'yes',
      openDialog: false,
      pickupAddressType: 'residential',
      dropAddressType: 'residential',
      pickupResults: [],
      dropResults: [],
      originDistError: true,
      dropDistError: true,
      supportedDistance: 0
    };
  }

  componentDidMount = () => {
    this.initializeDirections();
    this.getSupportedCitiesConfig();
  }

  componentWillUnmount = () => {
    // this.removeDirections();
  }

  initializeDirections = () => {
    const map = this.getMapboxMap();

    this.directions = new MapboxDirections({
      accessToken: mapboxgl.accessToken,
      profile: 'mapbox/driving',
      interactive: false
    });

    this.subscribeEvents();

    map.addControl(this.directions, 'top-left');
  }

  getMapboxMap = () => {
    const map = new mapboxgl.Map({
      container: this.mapContainerRef.current,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [-95.3, 29.75],
      zoom: 10,
    });

    // Add navigation control (the +/- zoom buttons)
    map.addControl(new mapboxgl.NavigationControl(), 'top-right');

    return map;
  }

  subscribeEvents = () => {
    this.directions.on('profile', this.handleRouteProfile);
    this.directions.on('origin', this.handleOrigin);
    this.directions.on('destination', this.handleDrop);
    this.directions.on('route', this.handleRoute);
    this.directions.on('error', this.handleError);
  }

  // unsubscribeEvents = () => {
  //   this.directions.off('profile', this.handleRouteProfile);
  //   this.directions.off('origin', this.handleOrigin);
  //   this.directions.off('destination', this.handleDrop);
  //   this.directions.off('route', this.handleRoute);
  //   this.directions.off('error', this.handleError);
  // }

  // removeDirections = () => {
  //   const mapboxMap = this.getMapboxMap();

  //   this.unsubscribeEvents();
  //   if (mapboxMap && mapboxMap.removeControl) {
  //     this.getMapboxMap().removeControl(this.directions);
  //   }

  //   this.directions = null;
  // }

  // getRegion = (cord, key) => {
  //   axios.get(
  //     `https://api.mapbox.com/geocoding/v5/mapbox.places/${cord[0]},${cord[1]}.json?types=address&access_token=${mapboxgl.accessToken}`,
  //     {
  //       timeout: 30000,
  //     },
  //   ).then((data) => {
  //     if (data.data.features.length > 0) {
  //       let city = data.data.features[0].place_name.split(",");
  //       city = city[city.length - 3];
  //       city = city.replace(" ", "").toLowerCase();
  //       this.setState({
  //         [`${key}City`]: city,
  //       });
  //     } else {
  //       this.setState({
  //         [`${key}City`]: null
  //       });
  //       alert(`We not able to verify ${key} address!! Please check again`);
  //     }
  //   }).catch((err) => {
  //     console.error(err);
  //     alert('Something went wrong!!!');
  //   });
  // }

  handleRouteProfile = (event) => {
    this.setState({
      routeProfile: event.profile,
    });
  }

  handleOrigin = (event) => {
    // if (this.originTimeout) {
    //   clearTimeout(this.originTimeout);
    // }
    // this.originTimeout = setTimeout(() => {
      // this.getRegion(event.feature.geometry.coordinates, 'pickup');
      const { coordinates } = event.feature.geometry;
      const { supportedCitiesConfig } = this.state;

      const pickupCord = new mapboxgl.LngLat(coordinates[0], coordinates[1]);
      let originDistError = true;
      let supportedDistance = 0;
      for (let i = 0; i < supportedCitiesConfig.length; i++) {
        if (supportedCitiesConfig[i].city === this.state.pickupCity) {
          const centerOfCord = new mapboxgl.LngLat(supportedCitiesConfig[i].cord[0], supportedCitiesConfig[i].cord[1]);
          const dist = convertMeterToMile(centerOfCord.distanceTo(pickupCord));
          if (dist < supportedCitiesConfig[i].radius) {
            supportedDistance = supportedCitiesConfig[i].distance;
            originDistError = false;
            break;
          }
        }
      }

      this.setState({
        originCord: event.feature.geometry.coordinates,
        originDistError,
        supportedDistance
      });
    // }, 1000);
  }

  handleDrop = (event) => {
    // if (this.dropTimeout) {
    //   clearTimeout(this.dropTimeout);
    // }
    // this.dropTimeout = setTimeout(() => {
      // this.getRegion(event.feature.geometry.coordinates, 'drop');
      const { coordinates } = event.feature.geometry;
      this.setState({
        dropCord: coordinates
      });
    // }, 1000);
  }

  handleRoute = (event) => {
    if (event.route.length > 0 && event.route[0].hasOwnProperty('distance')) {
      let dropDistError = true;
      const distance = convertMeterToMile(event.route[0].distance);
      const { supportedCitiesConfig } = this.state;
      for (let i = 0; i < supportedCitiesConfig.length; i++) {
        if (supportedCitiesConfig[i].city === this.state.pickupCity && distance <= supportedCitiesConfig[i].distance) {
          dropDistError = false;
          break;
        }
      }
      this.setState({
        distance,
        duration: convertSecondToHour(event.route[0].duration),
        dropDistError
      });
    }
  }

  handleError = (event) => {
    console.error(event);
  }

  pickupDateChange = (event) => {
    this.setState({
      pickupDate: event,
    });
  }

  dropDateChange = (event) => {
    this.setState({
      dropDate: event,
    });
  }

  inputChanged =  (val, key) => {
    let showAssistAvailable = null;
    if (key === 'parcelWeight' && parseInt(val, 10) > 50) {
      showAssistAvailable = true;
    } else if (key === 'parcelWeight') {
      showAssistAvailable = false;
    }
    this.setState({
      [key]: val,
      showAssistAvailable: showAssistAvailable !== null ? showAssistAvailable : this.state.showAssistAvailable,
    });

    if (key === 'originAddress') {
      let city = val.split(",");
      city = city[city.length - 3];
      city = city.replace(" ", "").toLowerCase();
      this.setState({
        pickupCity: city,
      });
    } else if (key === 'dropAddress') {
      let city = val.split(",");
      city = city[city.length - 3];
      city = city.replace(" ", "").toLowerCase();
      this.setState({
        dropCity: city,
      });
    }
  }

  setMap = (cord, key) => {
    if (key === 'pickup') {
      this.directions.setOrigin(cord);
    } else {
      this.directions.setDestination(cord);
    }
  }

  getSupportedCitiesConfig = () => {
    axios.get(`${getAPIUrl()}/quote/supportedCitiesConfig`, {
      timeout: 30000,
    }).then((response) => {
      this.setState({
        supportedCitiesConfig: response.data.supportedCities,
      });
    }).catch((error) => {
      console.error(error);
      alert('Something went wrong!!!');
    });
  }

  handleSubmit = () => {
    if (this.state.originCord === null || this.state.originAddress === '') {
      alert('Missing field: Pickup location');
      return;
    }

    if (this.state.dropCord === null || this.state.dropAddress === '') {
      alert('Missing field: Drop location');
      return;
    }

    if (this.state.parcelWeight === null) {
      alert('Missing field: Package weight');
      return;
    }

    if (this.state.pickupCity === null || this.state.dropCity === null) {
      alert('We are not able to verify the address!! Please check again');
      return;
    }

    if (parseInt(this.state.parcelWeight, 10) > 80) {
      alert('We currently don\'t support more than 80lbs');
      return;
    }

    if (this.state.showAssistAvailable && this.state.parcelAssistAvailable !== 'yes') {
      alert('We currently don\'t support package without assist for more than 50lbs');
      return;
    }

    if (this.state.pickupDate.getTime() <= new Date().getTime()) {
      alert('Pickup Time is incorrect');
      return;
    }

    if (this.state.dropDate.getTime() <= this.state.pickupDate.getTime()) {
      alert('Drop Time is incorrect');
      return;
    }

    if (this.state.routeProfile !== 'mapbox/driving') {
      alert('Incorrect route profile selected');
      return;
    }

    if (this.state.distance == null || this.state.duration == null) {
      alert('Something went wrong!! Please try again');
      return;
    }

    if (this.state.originDistError) {
      alert('The pickup location is not currently supported. Please select different address.');
      return;
    }

    if (this.state.dropDistError) {
      alert(`We currently support ${this.state.supportedDistance} miles from your selected pickup location. Please select different drop address.`);
      return;
    }

    if (this.state.dropDate.getTime() <= this.state.pickupDate.getTime()
    + this.state.duration * 60 * 60 * 1000 + 60 * 60 * 1000) {
      alert(`Estimated time to deliver this would be ${Math.round(this.state.duration) + 2} hrs, but we would try our best to deliver as early as possible`);
    }

    let isPickupBusiness = false;
    let isDropBusiness = false;
    if (this.state.pickupAddressType === 'business') {
      isPickupBusiness = true;
    }

    if (this.state.dropAddressType === 'business') {
      isDropBusiness = true;
    }

    this.setState({
      isLoading: true,
    });

    let { originAddress, originAddressDetail, dropAddress, dropAddressDetail } = this.state;

    if (originAddressDetail !== '') {
      originAddress = `${originAddressDetail}, ${originAddress}`;
    }

    if (dropAddressDetail !== '') {
      dropAddress = `${dropAddressDetail}, ${dropAddress}`;
    }

    axios.post(`${getAPIUrl()}/quote`, {
      distance: this.state.distance,
      duration: this.state.duration,
      originCord: [...this.state.originCord].reverse(),
      originAddress,
      pickupCity: this.state.pickupCity,
      dropCord: [...this.state.dropCord].reverse(),
      dropAddress,
      dropCity: this.state.dropCity,
      pickupDate: moment(this.state.pickupDate).format(),
      dropDate: moment(this.state.dropDate).format(),
      vehicleType: this.state.vehicleType,
      parcelWeight: parseInt(this.state.parcelWeight, 10),
      isPickupBusiness,
      isDropBusiness,
    }, {
      timeout: 30000,
    }).then((response) => {
      this.setState({
        isLoading: false,
        // openDialog: true,
        totalPrice: response.data.totalPrice,
      });

      this.props.addQuote({
        originAddress,
        dropAddress,
        pickupDate: this.state.pickupDate,
        dropDate: this.state.dropDate,
        vehicleType: this.state.vehicleType,
        parcelWeight: this.state.parcelWeight,
        totalPrice: response.data.totalPrice,
        quoteId: response.data.quoteId,
      });

      this.props.setActiveStep(1);
    }).catch((error) => {
      this.setState({
        isLoading: false,
      });
      if (error.response && error.response.status === 400) {
        alert(error.response.data.message);
      } else {
        console.error(error);
        alert('Something went wrong!!!');
      }
    });
  }

  handleParcelSizeChange = (event) => {
    this.setState({
      vehicleType: event.target.value,
    });
  }

  handlePickupAddressType = (event) => {
    this.setState({
      pickupAddressType: event.target.value,
    });
  }

  handleDropAddressType = (event) => {
    this.setState({
      dropAddressType: event.target.value,
    });
  }

  search = (query, key) => {
    if (query === '') return;
    if (this.originTimeout) {
      clearTimeout(this.originTimeout);
    }
    this.originTimeout = setTimeout(() => {
      axios.get(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?types=address&access_token=${mapboxgl.accessToken}`,
        {
          timeout: 30000,
        },
      ).then((data) => {
        this.setState({
          [key]: data.data.features
        });
      });
    }, 1000);
  }

  handleParcelAssist = (event) => {
    if (event.target.value !== 'yes') {
      alert('We currently don\'t support package without assist for more than 50lbs');
    }

    this.setState({
      parcelAssistAvailable: event.target.value,
    });
  }

  goToNextStep = () => {
    this.props.setActiveStep(1);
  }

  handleDialogClose = () => {
    this.setState({
      openDialog: false,
    });
  }

  expectedDeliverMinTime = () => {
    let duration = 0;
    if (this.state.duration != undefined) {
      duration = this.state.duration * 60 * 60 * 1000;
    }
    return new Date(this.state.pickupDate.getTime() + duration + (2 * 60 * 60 * 1000));
  }

  render() {
    return (
      <Container>
        <Grid container spacing={3} className="form-container">
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <Form className="main-form">
              <Form.Group>
                <TextField
                  label="Package weight(in lbs)"
                  onChange={(e) => this.inputChanged(e.target.value, 'parcelWeight')}
                  variant="outlined"
                  size="small"
                  inputProps={{ maxLength: 2 }}
                  required
                />
              </Form.Group>
              {
              this.state.showAssistAvailable
                ? (
                  <Form.Group>
                    <FormControl component="fieldset">
                      <FormLabel component="legend">Package Pickup &amp; Drop Assist Available</FormLabel>
                      <RadioGroup row defaultValue="yes" aria-label="contact-detail" name="customized-radios" onChange={this.handleParcelAssist}>
                        <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                        <FormControlLabel value="no" control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Form.Group>
                )
                : null
              }
              <Form.Group>
                <InputLabel id="parcel-size-select-label">Select package size that fits in</InputLabel>
                <Select
                  labelId="parcel-size-select-label"
                  id="parcel-size-select"
                  value={this.state.vehicleType}
                  onChange={this.handleParcelSizeChange}
                >
                  <MenuItem value="sedan">Sedan</MenuItem>
                  <MenuItem value="suv">SUV</MenuItem>
                  <MenuItem value="truck">Truck</MenuItem>
                </Select>
              </Form.Group>
              <Typography variant="h6" style={{ margin: '1rem 0px' }}>Pickup Address Detail</Typography>
              <Form.Group>
                <FormControl component="fieldset">
                  <FormLabel component="legend">Address Type</FormLabel>
                  <RadioGroup row defaultValue="residential" aria-label="contact-detail" name="customized-radios" onChange={this.handlePickupAddressType}>
                    <FormControlLabel value="residential" control={<Radio />} label="Residential" />
                    <FormControlLabel value="business" control={<Radio />} label="Business" />
                  </RadioGroup>
                </FormControl>
              </Form.Group>
              <Form.Group>
                <TextField
                  label="Pickup Address"
                  value={this.state.originAddress}
                  onChange={(e) => {
                    this.setState({ originAddress: e.target.value });
                    this.search(e.target.value, 'pickupResults');
                  }}
                  helperText="shown as (A) on map"
                  variant="outlined"
                  size="small"
                  required
                />
                {this.state.pickupResults.length > 0 && (
                  <ul className={`${this.props.showLoader && this.state.loading ? 'loading' : ''} suggest-list-ul`}>
                    {this.state.pickupResults.map((result, i) => (
                      <li key={result.id}>
                        <a onClick={() => {
                          this.setState({ pickupResults: [] });
                          this.inputChanged(result.place_name, 'originAddress');
                          this.setMap(result.center, 'pickup');
                        }}>
                          {result.place_name}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </Form.Group>
              <Form.Group>
                <TextField
                  label="Suite, Apt, Unit number or Business name"
                  onChange={(e) => this.inputChanged(e.target.value, 'originAddressDetail')}
                  variant="outlined"
                  inputProps={{ maxLength: 50 }}
                  size="small"
                />
              </Form.Group>
              <Form.Group>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <DateTimePicker
                    variant="inline"
                    label="Expected Pickup by"
                    value={this.state.pickupDate}
                    minDate={new Date(new Date().getTime() + (30 * 60 * 1000))}
                    maxDate={new Date(new Date().getTime() + (7 * 24 * 60 * 60 * 1000))}
                    minutesStep={15}
                    onChange={this.pickupDateChange}
                  />
                </MuiPickersUtilsProvider>
              </Form.Group>
              <Typography variant="h6" style={{ margin: '1rem 0px' }}>Drop Address Detail</Typography>
              <Form.Group>
                <FormControl component="fieldset">
                  <FormLabel component="legend">Address Type</FormLabel>
                  <RadioGroup row defaultValue="residential" aria-label="contact-detail" name="customized-radios" onChange={this.handleDropAddressType}>
                    <FormControlLabel value="residential" control={<Radio />} label="Residential" />
                    <FormControlLabel value="business" control={<Radio />} label="Business" />
                  </RadioGroup>
                </FormControl>
              </Form.Group>
              <Form.Group>
                <TextField
                  label="Drop Address"
                  value={this.state.dropAddress}
                  onChange={(e) => {
                    this.setState({ dropAddress: e.target.value });
                    this.search(e.target.value, 'dropResults');
                  }}
                  helperText="shown as (B) on map"
                  variant="outlined"
                  size="small"
                  required
                />
                {this.state.dropResults.length > 0 && (
                  <ul className={`${this.props.showLoader && this.state.loading ? 'loading' : ''} suggest-list-ul`}>
                    {this.state.dropResults.map((result, i) => (
                      <li key={result.id}>
                        <a onClick={() => {
                          this.setState({ dropResults: [] });
                          this.inputChanged(result.place_name, 'dropAddress');
                          this.setMap(result.center, 'drop');
                        }}>
                          {result.place_name}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </Form.Group>
              <Form.Group>
                <TextField
                  label="Suite, Apt, Unit number or Business name"
                  onChange={(e) => this.inputChanged(e.target.value, 'dropAddressDetail')}
                  variant="outlined"
                  inputProps={{ maxLength: 50 }}
                  size="small"
                />
              </Form.Group>
              <Form.Group>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <DateTimePicker
                    variant="inline"
                    label="Expected Deliver by"
                    value={this.state.dropDate}
                    minDate={this.expectedDeliverMinTime()}
                    maxDate={new Date(this.state.pickupDate.getTime() + (2 * 24 * 60 * 60 * 1000))}
                    minutesStep={15}
                    onChange={this.dropDateChange}
                  />
                </MuiPickersUtilsProvider>
              </Form.Group>
              <Button variant="contained" color="primary" onClick={this.handleSubmit}>Next</Button>
            </Form>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={8}>
            <div className="map-container" ref={this.mapContainerRef} />
          </Grid>
        </Grid>
        <Backdrop className="loading-indicator" open={this.state.isLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Dialog
          open={this.state.openDialog}
          onClose={this.handleDialogClose}
          aria-labelledby="quote-dialog-box"
        >
          <DialogTitle id="quote-dialog">Quote price</DialogTitle>
          <DialogContent>
            <DialogContentText>
              &#36;
              {' '}
              {this.state.totalPrice}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={this.handleDialogClose}>
              Disagree
            </Button>
            <Button onClick={this.goToNextStep} color="primary" autoFocus>
              Agree
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    );
  }
}

export default Map;
